import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { BreadcrumbItemType, BreadcrumbProps } from "./types";

export const useBreadcrumb = ({
  customItems,
  customLabel,
  defaultPath,
}: BreadcrumbProps) => {
  const router = useRouter();
  const translate = useTranslations("breadcrumb");

  const buildBreadcrumbs = (): BreadcrumbItemType[] => {
    const pathWithoutQuery = defaultPath || router.asPath.split("?")[0];

    let pathArray = pathWithoutQuery.split("/");
    pathArray.shift();

    pathArray = pathArray.filter(Boolean);

    return pathArray.map((path, index) => {
      const isLast = index + 1 >= pathArray.length;

      return {
        href: isLast ? "" : "/" + pathArray.slice(0, index + 1).join("/"),
        label:
          customLabel !== undefined
            ? isLast
              ? customLabel
              : translate(path)
            : translate(path),
      };
    });
  };

  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItemType[]>(
    customItems?.length ? customItems : buildBreadcrumbs()
  );

  useEffect(() => {
    if (customItems?.length) {
      setBreadcrumbs(customItems);
    } else {
      setBreadcrumbs(buildBreadcrumbs());
    }
  }, [router.asPath, customItems]);

  return {
    breadcrumbs,
    translate,
  };
};
